import PropTypes from 'prop-types';
import { usePermissions, regex, useTranslate } from 'react-admin';
import { Typography, Box } from '@mui/material';
import CustomCreate from '@/components/global/list/CustomCreate.jsx';
import CustomCloseButton from '@/components/global/buttons/CustomCloseButton.jsx';
import { UserForm } from '@/components/users/forms/UserForm.jsx';
import { formTransform } from '@/components/users/forms/formTransform.js';
import { StyledUserDrawer } from '@/components/users/forms/UserEdit.jsx';

export const UserCreate = ({ handleClose = () => {} }) => {
    const { isLoading, permissions } = usePermissions();
    const translate = useTranslate();

    if (isLoading) return null;

    const isAdmin = permissions.isAdmin;
    const validatePhone = regex(/^(\+48)[1-9]\d{8}$/, translate('resources.user.validation.invalidPhone'));
    const invalidEmail = translate('common.validation.invalidEmail');

    return (
        <StyledUserDrawer>
            <Box className='popup-wrapper popup-wrapper-top'>
                <Box className='popup-box popup-box--header'>
                    <Typography variant='h4'>{translate('resources.user.labels.createUser')}</Typography>
                    <Box>
                        <CustomCloseButton onClose={handleClose} />
                    </Box>
                </Box>
            </Box>
            <CustomCreate handleClose={handleClose} transform={formTransform}>
                <UserForm isAdmin={isAdmin} validatePhone={validatePhone} invalidEmail={invalidEmail} handleClose={handleClose} isEdit={false} />
            </CustomCreate>
        </StyledUserDrawer>
    );
};

UserCreate.propTypes = {
    handleClose: PropTypes.func,
};
